import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { ThemeProvider } from '@emotion/react';
import MuiChip from '@mui/material/Chip';
import Box from '../Box/Box.js';
import chipTheme from './Chip.theme.js';
import ClearIcon from '@mui/icons-material/Clear';

const FilledChipIcon = ({ outlined }) => (jsx(Box, { sx: {
        height: '0.25rem',
        width: '0.25rem',
        borderRadius: '50%',
        border: '2px solid',
    }, className: `custom-chip-icon ${outlined ? '' : 'filled'}` }));
/**
 * https://mui.com/api/chip/
 */
const CustomChipIcon = ({ useDefaultIcon, iconVariant, }) => {
    switch (true) {
        case iconVariant === 'filled':
            return jsx(FilledChipIcon, {});
        case iconVariant === 'outlined':
            return jsx(FilledChipIcon, { outlined: true });
        case useDefaultIcon:
            return jsx(FilledChipIcon, {});
        default:
            return null;
    }
};
const Chip = (_a) => {
    var { children, color, iconVariant, size } = _a, props = __rest(_a, ["children", "color", "iconVariant", "size"]);
    const useDefaultIcon = !!iconVariant ||
        (iconVariant !== null && ['error', 'info', 'success', 'warning'].includes(color || ''));
    return (jsx(ThemeProvider, Object.assign({ theme: chipTheme }, { children: jsx(MuiChip, Object.assign({ color: color, sx: useDefaultIcon ? { paddingLeft: '0.75rem' } : null, icon: jsx(CustomChipIcon, { useDefaultIcon: useDefaultIcon, iconVariant: iconVariant }), size: size ? size : 'small' }, props, { children: children })) })));
};
const DeletableChip = (props) => {
    return jsx(Chip, Object.assign({ deleteIcon: jsx(ClearIcon, {}) }, props));
};

export { DeletableChip, Chip as default };
//# sourceMappingURL=Chip.js.map
